import cn from "classnames";
import { useMemo } from "react";

import stylesPromoCode from "../../cart/cart-promo-code.module.scss";
import styles from "./skeleton-cart-totals.module.scss";

export default function SkeletonCartTotals() {
  const totalLine = useMemo(() => {
    return (
      <div className={cn(styles.line)}>
        <p className={cn(styles.block, styles.backgroundLightGray)}></p>
        <span className={cn(styles.arrow, styles.backgroundLightGray)}></span>
      </div>
    );
  }, []);

  const freeShipping = useMemo(() => {
    return (
      <div className={cn(styles.line)}>
        <p className={cn(styles.block, styles.blockWide, styles.backgroundLightGray)}></p>
      </div>
    );
  }, []);

  const button = useMemo(() => {
    return (
      <div className={cn(styles.line)}>
        <p className={cn(styles.button, styles.backgroundLightGray)}></p>
      </div>
    );
  }, []);

  return (
    <div className={cn(styles.container, stylesPromoCode.container, "pulseAnimation")}>
      {totalLine}
      {totalLine}
      {freeShipping}
      <div className="divider"></div>
      {totalLine}
      {button}
    </div>
  );
}
